import { useState, useEffect } from 'react';
import { Textarea } from '@/components/ui/textarea';

interface FormattedTextareaProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
}

export function FormattedTextarea({ value, onValueChange, placeholder }: FormattedTextareaProps) {
  // Keep internal state for the textarea value
  const [internalValue, setInternalValue] = useState(value || '');

  // Update internal value when prop changes
  useEffect(() => {
    setInternalValue(value || '');
  }, [value]);

  // Handle changes and sanitize text
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    
    // Sanitize the text - remove HTML tags and normalize line breaks
    const sanitizedValue = newValue
      .replace(/<[^>]*>/g, '') // Remove HTML tags
      .replace(/&nbsp;/g, ' ') // Replace &nbsp; with space
      .replace(/\r\n/g, '\n') // Normalize line breaks
      .replace(/\r/g, '\n')
      .replace(/\n\n+/g, '\n\n') // Remove excessive line breaks
      .trim();

    // Update internal state
    setInternalValue(newValue);
    
    // Send sanitized value to parent
    onValueChange(sanitizedValue);
  };

  return (
    <Textarea
      value={internalValue}
      onChange={handleChange}
      placeholder={placeholder}
      className="min-h-[100px]"
    />
  );
}